import SliderCaptcha, { ActionType } from "rc-slider-captcha";
import Refresh from "@/app/assets/user/Refresh.svg";
import React, { useRef, useState } from "react";
import { message as messageToast, Modal } from "antd";
import "./style/SliderVerification.css";
import { getCaptcha } from "@/service/user";
import { Captcha, VerifyType } from "@/service/user/enum";
import { generateUuid } from "@/utils/tools";
import { Storage } from "@/utils/storage";

export type SliderVerificationProps = {
  open: boolean;
  email: string;
  type: VerifyType;
  onClose: () => void;
  onSendSuccessClose: (type?: VerifyType) => void;
  verifyAction: () => void;
  onLoginWithPWDSuccess?: (data?: object) => void;
  step?: number;
  password?: React.Key;
};

export const SliderVerification: React.FC<SliderVerificationProps> = ({
  open,
  email,
  type,
  onClose,
  onSendSuccessClose,
  verifyAction,
  step,
  password,
  onLoginWithPWDSuccess,
  ...props
}) => {
  const actionRef = useRef<ActionType>();
  const [size, setSize] = useState({
    randomY: 0,
    sliderHeight: 0,
    sliderWidth: 0,
    originalHeight: 0,
    originalWidth: 0,
  });

  if (!open) {
    return null;
  }

  const getVerifyType = () => {
    if (type === VerifyType.SIGN_UP) {
      return Captcha.REGISTER;
    } else if (type === VerifyType.LOGIN) {
      return Captcha.LOGIN;
    } else if (type === VerifyType.RESET_PASS) {
      return Captcha.UPDATE_PASSWORD;
    }
  };

  return (
    <Modal
      open={open}
      width="32rem"
      centered
      closable={false}
      footer={null}
      maskClosable
      onCancel={onClose}
      className="Slider"
    >
      <div className="mb-16 text-center text-xl font-medium leading-26 text-bravve-100">
        Security Verification
      </div>
      <SliderCaptcha
        actionRef={actionRef}
        autoRefreshOnError={true}
        limitErrorCount={5}
        puzzleSize={{
          width: size.sliderWidth || 40,
          height: size.sliderHeight || 40,
          left: 0,
          top: size.randomY,
        }}
        bgSize={{
          width: size.originalWidth || 280,
          height: size.originalHeight || 160,
        }}
        request={async () => {
          let uuid;
          const { accountUuid, xPos } = Storage.getItem("SlideVerifyInfo");

          if (accountUuid === "") {
            uuid = generateUuid();
            Storage.setItem("SlideVerifyInfo", { accountUuid: uuid, xPos });
          } else {
            uuid = accountUuid;
          }

          const result = await getCaptcha(uuid, getVerifyType());
          const { data, message, status } = result;

          if (status === 200) {
            const {
              slidingImage,
              backImage,
              randomY,
              sliderHeight,
              sliderWidth,
              originalHeight,
              originalWidth,
            } = data;
            setSize({
              randomY,
              sliderHeight,
              sliderWidth,
              originalHeight,
              originalWidth,
            });

            return {
              bgUrl: backImage,
              puzzleUrl: slidingImage,
            };
          } else {
            messageToast.error(message);

            return {
              bgUrl: "",
              puzzleUrl: "",
            };
          }
        }}
        onVerify={async (data) => {

          const { accountUuid } = Storage.getItem("SlideVerifyInfo");

          Storage.setItem("SlideVerifyInfo", {
            accountUuid,
            xPos: Math.round(data.x),
          });
          onClose();
          return Promise.resolve();

          // 产品需求，校验成功后不立即调用登录的API，而是让用户自己再次点击登录按钮
          // if (step === 3) {
          //   // 后端判断验证吗类型有两套代码，前端需要另外处理
          //   const {
          //     status,
          //     message,
          //     data: loginRes,
          //   } = await login(
          //     {
          //       email,
          //       loginType: LoginType.PASSWORD,
          //       authorization: btoa(`${email}:${password}`),
          //     },
          //     Math.round(data.x),
          //     getVerifyType(),
          //     accountUuid,
          //   );

          //   // 必不可能为200， 因为密码错误
          //   if (status === 200) {
          //     onLoginWithPWDSuccess?.(loginRes);
          //     return Promise.resolve();
          //   } else if (status === StatusCode.SliderPasswordErr) {
          //     onClose();
          //     return Promise.resolve();
          //   } else {
          //     messageToast.error(message);
          //     return Promise.reject();
          //   }
          // }

          // // 后端判断验证吗类型有两套代码，前端需要另外处理
          // const { status, message } = await smsCode({
          //   email,
          //   type,
          //   xPos: Math.round(data.x),
          //   verifyType: getVerifyType(),
          //   uuid: accountUuid,
          // });

          // if (status === 200) {
          //   messageToast.success(
          //     messsage,
          //   );
          //   onSendSuccessClose();
          //   verifyAction();
          //   return Promise.resolve();
          // } else if (status === StatusCode.SmsSentRetryLater) {
          //   // 验证码已发送，请稍后再试，此时需要关闭滑块验证
          //   onSendSuccessClose(type);
          //   messageToast.error(message);
          //   return Promise.reject();
          // } else {
          //   messageToast.error(message);
          //   return Promise.reject();
          // }
        }}
        tipIcon={{
          default: (
            <iconpark-icon
              name="right"
              icon-id="right"
              color="#fff"
            ></iconpark-icon>
          ),
          refresh: <Refresh width={32} onClick={() => {}} />,
        }}
        tipText={{
          default: "Slide to complete the puzzle",
          loading: "Loading...",
          moving: "Slide right to the puzzle",
          verifying: "Verifying",
          error: "Failed",
          loadFailed: "Load failed",
          errors: "Too many failures, click Retry",
          success: "Successed",
        }}
        style={{
          "--rcsc-primary": "#402C22",
          "--rcsc-primary-light": "rgba(64,44,34, 0.2)",
          "--rcsc-error": "#C31010",
          "--rcsc-success": "rgb(36,150,27, 0.2)",
          "--rcsc-success-light": "rgb(36,150,27, 0.2)",
          "--rcsc-button-color": "#402C22",
          "--rcsc-button-hover-color": "#402C22",
          "--rcsc-button-bg-color": "#402C22",
          "--rcsc-text-color": "#796B64",
          "--rcsc-bg-color": "#DEDBD5",
          "--rcsc-border-color": "#C6C0BD",
          "--rcsc-panel-border-radius": ".2rem",
          "--rcsc-control-border-radius": ".2rem",
          "--rcsc-control-height": "4.4rem",
        }}
      />
    </Modal>
  );
};
